import React, { useEffect, useRef } from 'react'
import { withRouter } from 'react-router-dom'
import AxiosInstance from 'utils/AxiosInstance'

import {
  fetchTrackingByCourseContentScorm,
  onScormProgress,
  setSuspendDataOnMount,
  resetSuspendDataOnMount,
  finishContent,
} from 'store/Course/actions'
import { useDispatch } from 'react-redux'

const Scorm = (props) => {
  const dispatch = useDispatch()
  const iframeRef = useRef(null)

  const listenToMessage = (e) => {
    // Only trust messages that actually came from this SCORM iframe -
    // otherwise unrelated window messages (extensions, devtools, other
    // frames) can be misread as SCORM progress/completion signals.
    if (!iframeRef.current || e.source !== iframeRef.current.contentWindow) {
      return
    }

    const scormData = e['data']
    console.log('scormdata', scormData)
    if (
      scormData &&
      scormData.value !== undefined &&
      scormData.type == 'suspend_data'
    ) {
      dispatch(setSuspendDataOnMount(scormData))
    }

    const quizFailed =
      scormData == 'fail' ||
      (scormData && scormData.type == 'quiz_failed') ||
      (scormData &&
        (scormData.type == 'success_status' ||
          scormData.type == 'lesson_status') &&
        String(scormData.value).toLowerCase() == 'failed')

    if (quizFailed) {
      dispatch(
        onScormProgress(props.params, { type: 'quiz_failed', value: 'failed' })
      )
    } else if (
      scormData &&
      (scormData.type == 'suspend_data' ||
        scormData.type == 'success_status') &&
      scormData.value !== undefined
    ) {
      console.log('test', props.params, scormData)
      dispatch(onScormProgress(props.params, scormData))
    } else
      dispatch(fetchTrackingByCourseContentScorm(props.courseId, props.params))

    if (
      scormData == 'finish' ||
      //|| scormData == 'complete_scorm'
      (scormData.type == 'success_status' && scormData.value == 'passed') ||
      (scormData.type == 'EPL' && scormData.score > 79)
    ) {
      console.log('Learti42 SCORM FINISHED')
      dispatch(finishContent(props.courseId, props.params))
    }

    if (
      scormData &&
      scormData.type == 'success_status' &&
      scormData.value == 'passed'
    ) {
      dispatch(finishContent(props.courseId, props.params))
    }
  }

  useEffect(() => {
    dispatch(fetchTrackingByCourseContentScorm(props.courseId, props.params))
  }, [props.params])

  useEffect(() => {
    window.addEventListener('message', listenToMessage)
    // fetchTrackingByCourseContentScorm(
    // 	props.courseId,
    // 	props.params
    // )

    return () => {
      window.removeEventListener('message', listenToMessage)
    }
  })

  return (
    <div style={{ height: '100%' }} className='responsive-scorm'>
      <iframe
        ref={iframeRef}
        src={props.url}
        style={{
          width: props.url ? '100%' : '0',
          height: props.url ? '100%' : '0',
        }}
        frameBorder='0'
        allow='autoplay'
      ></iframe>
    </div>
  )
}

class ViewScorm extends React.Component {
  state = {
    url: '',
    suspendData: null,
  }

  initScorm = (reset = false, suspendData = null) => {
    if (reset) {
      this.setState({
        url:
          this.props.url.replace('user_id=1', `user_id=${this.props.user.id}`) +
          '&name=' +
          encodeURIComponent(this.props.user.name) +
          '&startkiwi=true',
      })
      return
    }

    const tracking = suspendData ?? this.state.suspendData
    const baseUrl =
      this.props.url.replace('user_id=1', `user_id=${this.props.user.id}`) +
      '&name=' +
      encodeURIComponent(this.props.user.name) +
      '&startkiwi=true'

    if (
      tracking != null &&
      Object.keys(tracking).length > 0 &&
      tracking.value
    ) {
      this.setState({
        url: baseUrl + '&suspend_data=' + encodeURIComponent(tracking.value),
      })
    } else {
      this.setState({ url: baseUrl })
    }
  }

  componentDidMount() {
    this.fetchSuspendData()
  }

  async fetchSuspendData() {
    const data = await AxiosInstance.get(
      `/tracking?courseId=${this.props.courseId}&contentId=${this.props.params}`
    )
    const suspendData = data?.data ?? null

    this.setState({ suspendData })
    this.initScorm(false, suspendData)
  }

  componentDidUpdate(prevProps) {
    let scormUrl
    if (prevProps.params != this.props.params) {
      this.fetchSuspendData()
      return
    }
  }

  render() {
    return <Scorm {...this.props} url={this.state.url} />
  }
}

export default withRouter(ViewScorm)
